module.exports = __webpack_public_path__ + "static/media/baby-6000verticalPixels.38847232.jpg";